import React, { useEffect, useState, useCallback } from "react";
import { fileValidation, getSizeDimension } from "../../../services/utils";
import { extractFileExtensions } from "../../../services/utils";
import { useNotValidFilesState } from "../../../states/useStates";
import { MdDeleteOutline } from "react-icons/md";
import { useRecoilState } from "recoil";
import {
  connectorErrorsState,
  isConnectorValidState,
} from "../../../states/atoms";
import Input from "../../Forms/Input";
import InputTags from "../../InputTags/InputTags";
import toast from "react-hot-toast";
import FilePreviewDialog from "@/components/FilePreviewDialog/FilePreviewDialog";

function ListUploadedFile({
  handleFileRemove,
  handleFileChange,
  setFiles,
  files,
  validFormat,
}) {
  const [notValidFiles, setNotValidFiles] = useNotValidFilesState();
  const [total, setTotal] = useState(null);
  const hiddenFileInput = React.useRef(null);
  const [selectedFile, setSelectedFile] = useState();
  const [description, setDescription] = useState("");

  const [isConnectorValid, setIsConnectorValid] = useRecoilState(
    isConnectorValidState
  );

  const [connectorErrors, setConnectorErrors] =
    useRecoilState(connectorErrorsState);

  const addMetadata = (target, metadata) => {
    const updatedFiles = files.map((item) => {
      if (item.name === target) {
        item.tags = metadata;
      }
      return item;
    });

    setFiles(updatedFiles);
  };

  const handleTags = (tags) => {
    if (selectedFile) {
      addMetadata(selectedFile.name, tags);
    }
  };

  const handleAddDescription = (target, description) => {
    setDescription(description);
    const updatedFiles = files.map((item) => {
      if (item.name === target) {
        item.description = description;
      }
      return item;
    });
    setFiles(updatedFiles);
  };

  const handleUploadClick = () => {
    hiddenFileInput.current.click();
  };

  const handleFileUpload = (e) => {
    const arr = Array.from(e.target.files);
    const validFiles = fileValidation(validFormat, arr, "free-text");

    handleFileChange(validFiles);
  };

  const notifyInvalidFiles = (files) => {
    toast(
      <div className="flex flex-col gap-2">
        <div className="flex gap-2">
          <div className="text-lg">⚠️</div>
          <h2>The following files are not valid for the selected connector:</h2>
        </div>
        <div className="flex flex-col gap-2">
          {files.map((file) => (
            <p>📄 {file.name}</p>
          ))}
        </div>
      </div>
    );
  };

  // turn off connector-specific validation
  useEffect(() => {
    setIsConnectorValid(true);
  });

  useEffect(() => {
    let totalSize = 0;
    files.map((item) => {
      totalSize += item.size;
    });

    setTotal(getSizeDimension(totalSize));
    if (selectedFile === undefined) {
      setSelectedFile(files[0]);
    } else {
      setSelectedFile(selectedFile);
    }
  }, [files, selectedFile]);

  useEffect(() => {
    setDescription(selectedFile?.description || "");
  }, [selectedFile]);

  return (
    <div className="relative overflow-x-auto p-5 bg-white rounded flex  gap-5 overflow-scroll shadow">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 w-full">
        {files &&
          files.map((item, index) => (
            <div
              key={index}
              className={`${
                selectedFile && selectedFile.name === item.name
                  ? "bg-primary text-white"
                  : ""
              } p-2 border border-gray/20 rounded flex items-center justify-between cursor-pointer hover:bg-primary hover:text-white w-full`}
              onClick={() => setSelectedFile(item)}
            >
              <div className="flex items-center gap-2">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/file_type/" +
                    extractFileExtensions(item.name, true) +
                    ".png"
                  }
                  alt="file extension icon"
                  className="h-6 lg:h-12"
                />
                <div className="flex flex-col lg:flex-row gap-x-2 min-w-0 gap-y-1">
                  <span className="text-xs font-bold truncate max-w-[12rem]">
                    {item.name}
                  </span>
                  <span className="text-xs">{getSizeDimension(item.size)}</span>
                </div>
              </div>
              {/* <MdDeleteOutline
                className="text-xl cursor-pointer"
                onClick={() => handleFileRemove(item)}
              /> */}
              <div className="flex items-center gap-2">
                <FilePreviewDialog file={item} />
                <MdDeleteOutline
                  className="text-xl cursor-pointer"
                  onClick={() => handleFileRemove(item)}
                />
              </div>
            </div>
          ))}
        <div
          className="border border-dotted text-xs lg:text-sm border-gray/20 p-5 rounded text-gray/50 hover:border-gray hover:text-gray cursor-pointer w-full"
          onClick={() => handleUploadClick()}
        >
          + Click to add new file
        </div>
        <input
          type="file"
          ref={hiddenFileInput}
          onChange={(e) => handleFileUpload(e)}
          style={{ display: "none" }}
          multiple
        />
      </div>
    </div>
  );
}

export default ListUploadedFile;
